import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid manager-card" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexFileManeger',
  setup(__props) {

const FileSidebar = defineAsyncComponent(() => import("@/components/theme/filemaneger/FileSidebar.vue"))
const FileContent = defineAsyncComponent(() => import("@/components/theme/filemaneger/FileContent.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "App",
      mains: "File manager",
      title: "File manager"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(FileSidebar)),
        _createVNode(_unref(FileContent))
      ])
    ])
  ], 64))
}
}

})